import { render, staticRenderFns } from "./OffersView.vue?vue&type=template&id=4f8f8016&"
import script from "./OffersView.vue?vue&type=script&lang=js&"
export * from "./OffersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports